import { useState } from "react";
import { RefreshCw } from "lucide-react";

export function SplashPreview() {
  const [key, setKey] = useState(0);
  return (
    <div className="flex flex-col items-center gap-4">
      <div className="relative rounded-[2.2rem] border-[6px] border-neutral-800 bg-black shadow-2xl overflow-hidden" style={{ width: 210, height: 430 }}>
        <div className="absolute left-1/2 -translate-x-1/2 top-1.5 h-4 w-20 rounded-full bg-neutral-800 z-10" />
        <div key={key} className="relative h-full w-full flex flex-col items-center justify-center" style={{ background: "#0A0A0A" }} data-testid="splash-preview-screen">
          <div className="absolute rounded-full blur-2xl" style={{ width: 200, height: 200, background: "radial-gradient(circle, rgba(0,122,255,0.45) 0%, transparent 70%)" }} />
          <img src="/logo192.png" alt="SphereHyx" className="relative h-16 w-16 rounded-2xl border border-white/10 shadow-xl animate-fade-up" />
          <h3 className="relative mt-4 font-heading font-extrabold text-lg tracking-tight text-white animate-fade-up">
            Sphere<span style={{ color: "#007AFF" }}>Hyx</span>
          </h3>
          <p className="relative mt-1 text-[11px] text-white/50 animate-fade-up">Connect · Manage · Grow</p>
          <div className="absolute bottom-10 h-1 w-16 overflow-hidden rounded-full bg-white/10">
            <div className="h-full origin-left rounded-full" style={{ background: "linear-gradient(90deg,#007AFF,#10B981)", animation: "splashbar 1.3s ease-in-out" }} />
          </div>
        </div>
      </div>
      <button onClick={() => setKey((k) => k + 1)} className="inline-flex items-center gap-1.5 text-xs text-secondary hover:underline" data-testid="splash-replay-btn">
        <RefreshCw size={13} /> Replay animation
      </button>
      <style>{`@keyframes splashbar{0%{transform:scaleX(0)}100%{transform:scaleX(1)}}`}</style>
    </div>
  );
}
